import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import MoneyTextField from "../../Inputs/MoneyTextField";

export default function PendentCashReturnDialog({ open, onClose, onConfirm }) {
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    if (!description.trim()) {
      setError(true);
      return;
    }
    setError(false);

    onConfirm({
      amount: parseFloat(amount) * 100,
      description,
      transactionType: 3,
      onClose,
    });
    setAmount("");
    setDescription("");
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ zIndex: 999999 }}>
      <DialogTitle>Pendência</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <MoneyTextField
            label="Digite o valor da Pendência"
            fullWidth
            value={amount}
            setValue={(val) => setAmount(val)}
          />

          <TextField
            label="Motivo"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            error={error} // Show error state
            helperText={error ? "O campo 'Motivo' é obrigatório." : ""} // Error message
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
